const page = "TyrePage";

export default page;

